import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import React, { useContext, createContext, useReducer } from 'react';
import { useHistory } from 'react-router';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import Keycloak from 'keycloak-js';
import { KEYCLOAK_CLIENT_NAME, UNAUTHORIZED_CODE, UNAUTHORIZED_PAGE, KEYCLOAK_TOKEN_NAME } from '@ea-webapp/commons/constants';
import { getEnv } from '@ea-webapp/commons/utils';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Reducer = function Reducer(state, action) {
  switch (action.type) {
    case "USER_INFOS":
      return _objectSpread(_objectSpread({}, state), {}, {
        user: action.user
      });
    case "UPDATE_USER_INFOS":
      return _objectSpread(_objectSpread({}, state), {}, {
        user: _objectSpread(_objectSpread({}, state.user), action.user)
      });
    case "TOKEN":
      return _objectSpread(_objectSpread({}, state), {}, {
        token: action.token
      });
    case "KEYCLOAK":
      return _objectSpread(_objectSpread({}, state), {}, {
        keycloak: action.keycloak
      });
    case "AUTH_DONE":
      return _objectSpread(_objectSpread({}, state), {}, {
        isAuthDone: action.isAuthDone
      });
    case "PROVISIONING_ACCOUNT":
      return _objectSpread(_objectSpread({}, state), {}, {
        provisioning: action.provisioning
      });
    default:
      return state;
  }
};

var initialState = {
  user: null,
  token: null,
  keycloak: null,
  isAuthDone: false,
  provisioning: false
};
var AuthContext = /*#__PURE__*/createContext(initialState);
var useAuth = function useAuth() {
  return useContext(AuthContext);
};

var defaultInitOptions = {
  url: getEnv("REACT_APP_KEYCLOAK_URL"),
  realm: getEnv("REACT_APP_KEYCLOAK_REALM"),
  clientId: getEnv("REACT_APP_KEYCLOAK_CLIENT"),
  onLoad: 'login-required',
  KeycloakResponseType: 'code'
};
var sigInitOptions = {
  url: getEnv("REACT_APP_KEYCLOAK_URL"),
  realm: getEnv("REACT_APP_SIG_KEYCLOAK_REALM"),
  clientId: getEnv("REACT_APP_SIG_KEYCLOAK_CLIENT"),
  onLoad: 'login-required',
  KeycloakResponseType: 'code'
};
var AuthProvider = function AuthProvider(_ref) {
  var children = _ref.children;
  var _useReducer = useReducer(Reducer, {}),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    authState = _useReducer2[0],
    dispatch = _useReducer2[1];
  var history = useHistory();
  function loginKeycloak(ssoAccountName, keycloakRealm, ssoUserLoginHandler) {
    var onError = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (msg) {
      console.error(msg);
    };
    var onSuccess = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (msg) {
      console.info(msg);
    };
    var useSigRealm = keycloakRealm === getEnv("REACT_APP_SIG_KEYCLOAK_REALM");
    var initOptions = useSigRealm ? sigInitOptions : defaultInitOptions;
    localStorage.setItem(KEYCLOAK_CLIENT_NAME, useSigRealm ? getEnv("REACT_APP_SIG_KEYCLOAK_CLIENT") : getEnv("REACT_APP_KEYCLOAK_CLIENT"));
    var keycloak = new Keycloak(initOptions);
    var kcLogin = keycloak.login;
    keycloak.login = function (options) {
      if (ssoAccountName) {
        options.idpHint = ssoAccountName;
      }
      return kcLogin.call(keycloak, options);
    };
    keycloak.init({
      onLoad: initOptions.onLoad
    }).then(/*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(auth) {
        var _keycloak$idTokenPars, response, _response$messages, _response$messages2, errMsgCode;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (auth) {
                _context.next = 4;
                break;
              }
              window.location.reload();
              _context.next = 23;
              break;
            case 4:
              if (!authState.token) {
                localStorage.setItem(KEYCLOAK_TOKEN_NAME, keycloak.token);
                dispatch({
                  type: "KEYCLOAK",
                  keycloak: keycloak
                });
                dispatch({
                  type: "TOKEN",
                  token: keycloak.token
                });
                dispatch({
                  type: "USER_INFOS",
                  user: keycloak.idTokenParsed
                });
              }
              if (!ssoAccountName) {
                dispatch({
                  type: "AUTH_DONE",
                  isAuthDone: true
                });
              }
              if (!(keycloak !== null && keycloak !== void 0 && (_keycloak$idTokenPars = keycloak.idTokenParsed) !== null && _keycloak$idTokenPars !== void 0 && _keycloak$idTokenPars.idp)) {
                _context.next = 21;
                break;
              }
              _context.prev = 7;
              _context.next = 10;
              return ssoUserLoginHandler();
            case 10:
              response = _context.sent;
              if (response) {
                window.location.reload();
              } else {
                dispatch({
                  type: "AUTH_DONE",
                  isAuthDone: true
                });
              }
              if (response !== null && response !== void 0 && response.content) {
                errMsgCode = ((_response$messages = response.messages) === null || _response$messages === void 0 ? void 0 : _response$messages.error) && ((_response$messages2 = response.messages) === null || _response$messages2 === void 0 || (_response$messages2 = _response$messages2.error[0]) === null || _response$messages2 === void 0 ? void 0 : _response$messages2.code);
                if (errMsgCode === UNAUTHORIZED_CODE) {
                  history.push("/" + UNAUTHORIZED_PAGE);
                }
              }
              _context.next = 18;
              break;
            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](7);
              onError("INTERNAL_ERROR");
            case 18:
              dispatch({
                type: "PROVISIONING_ACCOUNT",
                provisioning: true
              });
              _context.next = 22;
              break;
            case 21:
              dispatch({
                type: "AUTH_DONE",
                isAuthDone: true
              });
            case 22:
              // TODO : i18n ?
              onSuccess("Welcome " + (keycloak === null || keycloak === void 0 ? void 0 : keycloak.idTokenParsed.name));
            case 23:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[7, 15]]);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }())["catch"](function () {
      onError("INTERNAL_ERROR");
    });
  }
  function logoutKeycloak() {
    var _authState$user;
    var initOptions = localStorage.getItem(KEYCLOAK_CLIENT_NAME) === getEnv("REACT_APP_SIG_KEYCLOAK_CLIENT") ? sigInitOptions : defaultInitOptions;
    sessionStorage.clear();
    localStorage.removeItem(KEYCLOAK_TOKEN_NAME);
    localStorage.removeItem(KEYCLOAK_CLIENT_NAME);
    dispatch({
      type: "KEYCLOAK",
      keycloak: null
    });
    dispatch({
      type: "TOKEN",
      token: null
    });
    dispatch({
      type: "USER_INFOS",
      user: null
    });
    if (authState !== null && authState !== void 0 && (_authState$user = authState.user) !== null && _authState$user !== void 0 && _authState$user.idp) {
      window.location.href = "".concat(initOptions.url, "/realms/").concat(initOptions.realm, "/protocol/openid-connect/logout?initiating_idp=").concat(authState.user.idp, "&redirect_uri=https%3A%2F%2Fwww.aprovall.com");
    } else {
      authState.keycloak.logout();
    }
  }
  function updateUserInfos(user) {
    dispatch({
      type: "UPDATE_USER_INFOS",
      user: user
    });
  }
  return /*#__PURE__*/React.createElement(AuthContext.Provider, {
    value: {
      authState: authState,
      loginKeycloak: loginKeycloak,
      logoutKeycloak: logoutKeycloak,
      updateUserInfos: updateUserInfos
    }
  }, children);
};

export { AuthProvider, useAuth };
